module.exports = function(service) {
	'use strict'
	service.factory('comunicateBetweenViews', comunicateBetweenViews);
	comunicateBetweenViews.$inject = [];
	function comunicateBetweenViews() {
	   	var category;
	   	var tag;
	   	var author;
		var store;
		var service = {
		   	'setCategory':function(data) {
		   		category = data;
		   	},
		   	'getCategory':function() {
		   		return category 
		   	},	
		   	'setTag': function(data) {
		   		tag = data 
		   		
		   	},
		   	'getTag':function() {
		   		return tag
		   	},
		   	'setAuthor': function(data) {
		   		author = data
		   	},
		   	'getAuthor': function() {
		   		return author
		   	},
			'setStore': function(data) {
				store = data
			},
			'getStore': function() {
				return store
			}
		}
		return service 
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/comunicateBetweenViewsService.js
// module id = 590
// module chunks = 0